import request from '@/utils/request'

export { getUploadTempSignature } from '../background/api'

const RESOURCE_NAMES = [
  'category',
  'tag',
  'person',
  'surname',
  'migration-route',
  'recommendation'
]

export function getArticleList(params = {}) {
  return request.get('/heritage/admin/articles', params)
}

export function getArticleDetail(id) {
  return request.get('/heritage/admin/articles/detail', { id })
}

export function saveArticle(data) {
  return request.post('/heritage/admin/articles/save', data)
}

export function deleteArticle(id) {
  return request.post('/heritage/admin/articles/delete', { id })
}

export function getResourceList(resource, params = {}) {
  if (!RESOURCE_NAMES.includes(resource)) {
    return Promise.reject(new Error('未知资源类型'))
  }
  return request.get(`/heritage/admin/${resource}`, params)
}

export function getResourceDetail(resource, id) {
  if (!RESOURCE_NAMES.includes(resource)) {
    return Promise.reject(new Error('未知资源类型'))
  }
  return request.get(`/heritage/admin/${resource}/detail`, { id })
}

export function saveResource(resource, data) {
  if (!RESOURCE_NAMES.includes(resource)) {
    return Promise.reject(new Error('未知资源类型'))
  }
  return request.post(`/heritage/admin/${resource}/save`, data)
}

export function deleteResource(resource, id) {
  if (!RESOURCE_NAMES.includes(resource)) {
    return Promise.reject(new Error('未知资源类型'))
  }
  return request.post(`/heritage/admin/${resource}/delete`, { id })
}
